import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcCalendarcheckFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.75 1.875a.75.75 0 0 1 .75.75V4h7V2.625a.75.75 0 0 1 1.5 0V4h1.25A2.75 2.75 0 0 1 21 6.75v1.5H3v-1.5A2.75 2.75 0 0 1 5.75 4H7V2.625a.75.75 0 0 1 .75-.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 9.75v9.5A2.75 2.75 0 0 0 5.75 22h12.5A2.75 2.75 0 0 0 21 19.25v-9.5zm11.502 2.478-3.677 3.677-1.577-1.577a.74.74 0 0 0-.542-.233.74.74 0 0 0-.542.233.73.73 0 0 0-.228.547.75.75 0 0 0 .228.537l2.028 2.03q.271.27.633.27.361 0 .633-.27l4.129-4.13a.74.74 0 0 0 .232-.542.74.74 0 0 0-.232-.542.73.73 0 0 0-.547-.228.75.75 0 0 0-.538.228",
    clipRule: "evenodd"
  }));
}
var IcCalendarcheckFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCalendarcheckFill));

export { IcCalendarcheckFill as I };
